export const PLACEHOLDER_IMAGE_SRC =
  'https://cdn.shopify.com/s/files/1/0554/3493/6387/files/placeholder-images-image_large_3a310be0-8d4c-4458-9aac-39f3c3fa54f1.webp?v=1656048417';
